import { render, staticRenderFns } from "./PlatformTab.vue?vue&type=template&id=a45c810c&scoped=true"
import script from "./PlatformTab.vue?vue&type=script&lang=js"
export * from "./PlatformTab.vue?vue&type=script&lang=js"
import style0 from "./PlatformTab.vue?vue&type=style&index=0&id=a45c810c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45c810c",
  null
  
)

/* custom blocks */
import block0 from "./PlatformTab.vue?vue&type=custom&index=0&blockType=platform-tab&%3AtabData=tabData&%40tabChange=tabChange"
if (typeof block0 === 'function') block0(component)

export default component.exports